// TemplateOverlayManager.js - Enterprise-grade overlay management
// Ensures only one template overlay exists at a time for professional navigation

export class TemplateOverlayManager {
    constructor() {
        this.activeOverlay = null;
        this.overlayHistory = [];
        console.log('🎯 TemplateOverlayManager: Initialized for enterprise-grade navigation');
    }

    /**
     * Register a new template overlay and clean up any existing ones
     */
    registerOverlay(overlayId, sceneKey) {
        console.log(`🎯 TemplateOverlayManager: Registering overlay ${overlayId} for scene ${sceneKey}`);
        
        // Clean up any existing template overlays EXCEPT the one being registered
        this.cleanupAllTemplateOverlaysExcept(overlayId);
        
        // Register the new overlay
        this.activeOverlay = {
            id: overlayId,
            sceneKey: sceneKey,
            timestamp: Date.now()
        };
        
        // Add to history for navigation tracking
        this.overlayHistory.push(this.activeOverlay);
        
        console.log(`🎯 TemplateOverlayManager: Active overlay set to ${overlayId}`);
    }

    /**
     * Clean up all template scene overlays except auth-menu-dom-overlay and specified exception
     */
    cleanupAllTemplateOverlaysExcept(exceptOverlayId) {
        console.log(`🧹 TemplateOverlayManager: Cleaning up all template overlays except ${exceptOverlayId}...`);
        
        const templateOverlays = document.querySelectorAll('[id$="-scene-overlay"]');
        let cleanedCount = 0;
        
        templateOverlays.forEach(overlay => {
            // Don't remove the main dashboard overlay or the exception
            if (overlay.id !== 'auth-menu-dom-overlay' && overlay.id !== exceptOverlayId) {
                overlay.remove();
                cleanedCount++;
                console.log(`🧹 TemplateOverlayManager: Removed ${overlay.id}`);
            }
        });
        
        console.log(`🧹 TemplateOverlayManager: Cleaned up ${cleanedCount} template overlays (preserved ${exceptOverlayId})`);
    }

    /**
     * Clean up all template scene overlays except auth-menu-dom-overlay
     */
    cleanupAllTemplateOverlays() {
        this.cleanupAllTemplateOverlaysExcept(null);
        this.activeOverlay = null;
    }

    /**
     * Force cleanup before scene transition
     */
    prepareForTransition(targetSceneKey) {
        console.log(`🔄 TemplateOverlayManager: Preparing for transition to ${targetSceneKey}`);
        
        // Clean up all template overlays
        this.cleanupAllTemplateOverlays();
        
        // Clear history if going back to dashboard
        if (targetSceneKey === 'AuthenticatedMenuSceneDOM') {
            this.overlayHistory = [];
            console.log('🔄 TemplateOverlayManager: Cleared navigation history (returning to dashboard)');
        }
    }

    /**
     * Get the previous scene for back navigation
     */
    getPreviousScene() {
        if (this.overlayHistory.length > 1) {
            return this.overlayHistory[this.overlayHistory.length - 2].sceneKey;
        }
        return 'AuthenticatedMenuSceneDOM'; // Default to dashboard
    }

    /**
     * Check if we have multiple overlays (debugging)
     */
    auditOverlays() {
        const allOverlays = document.querySelectorAll('[id$="-overlay"], [id$="-scene-overlay"]');
        const visibleOverlays = Array.from(allOverlays).filter(o => 
            o.style.display !== 'none' && 
            o.style.visibility !== 'hidden' &&
            o.offsetParent !== null
        );
        
        console.log(`🔍 TemplateOverlayManager: Overlay audit - ${visibleOverlays.length} visible overlays:`);
        visibleOverlays.forEach((overlay, index) => {
            console.log(`🔍   ${index + 1}. ${overlay.id} (z-index: ${overlay.style.zIndex || 'auto'})`);
        });
        
        return visibleOverlays;
    }
}

// Create global instance
window.templateOverlayManager = new TemplateOverlayManager();

export default window.templateOverlayManager;
